const actions = {
  state: {
    // 브라우저 크기에 따라 네비게이션이 생겼다가 없어졌다가 하도록..
    drawer: null,
    title: null,
    responsive: false
  },
  mutations: {
    setDrawer (state, drawer) {
      state.drawer = drawer
    },
    setTitle (state, title) {
      state.title = title
    },
    setResponsive (state, responsive) {
      state.responsive = responsive
    }
  },
  actions: {
    setDrawer (context, drawer) {
      context.commit('setDrawer', drawer)
    },
    setTitle (context, title) {
      context.commit('setTitle', title)
    },
    setResponsive (context, responsive) {
      context.commit('setResponsive', responsive)
    }
  },
  getters: {
  }
}

export default actions
